import { FilterType } from "@/lib/filters";
import { FILTER_TYPE_ICONS } from "./FilterTypeOptions";

interface FilterTypeIconProps {
  filterType: FilterType;
  className?: string;
}

export const FilterTypeIcon = ({
  filterType,
  className,
}: FilterTypeIconProps) => {
  const Icon = FILTER_TYPE_ICONS[filterType];
  return <Icon className={className} />;
};
